<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'StepReject',
})
</script>
<template>
  <TlDetailItem title="驳回" color="red">
    <TlDetailField label="审核人">{{ record?.createAdminUserObj?.loginName }}</TlDetailField>
    <TlDetailField label="审核时间">{{ record?.createdAt }}</TlDetailField>
    <TlDetailField label="审核意见">{{ record?.shenHeYiJian }}</TlDetailField>
  </TlDetailItem>
</template>

<script lang="ts" setup name="StepReject">
import TlDetailField from '../common/TlDetailField.vue'
import TlDetailItem from '../common/TlDetailItem.vue'
defineProps<{
  record?: any
}>()
</script>
